import { mediaCards } from "@/mocks/homeData";

export default function MediaSection() {
  return (
    <section id="media" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            热播剧集
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            当前最受欢迎的热门电视剧，点击即可免费在线观看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaCards.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-300/50 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <span className="absolute top-2 left-2 text-[10px] font-medium text-background-50 bg-accent-500 px-2 py-0.5 rounded whitespace-nowrap">
                  {item.tag}
                </span>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                  <i className="ri-play-circle-line text-3xl text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-950 whitespace-nowrap overflow-hidden text-ellipsis">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-600 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
                <p className="mt-2 text-[11px] text-foreground-500 whitespace-nowrap">
                  {item.views}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}